import { BundleOptionKey } from 'interactive/bundle-options';
import { LogoTypeKey } from 'interactive/logo-types';
import { useState } from 'react';

export interface AppState {
    step?: number;
    industry?: string;
    logoTypes?: LogoTypeKey[];
    name?: string;
    bundle?: BundleOptionKey;
}

export default function useAppState(key: string, initialValue: AppState) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);

            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // No need to handle errors when reading the localStorage.
            return initialValue;
        }
    });

    const setValue = (value: any) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;

            setStoredValue(valueToStore);

            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // No need to handle errors when writing to localStorage.
        }
    };

    return [storedValue, setValue];
}

export function clearAppState(key: string) {
    window.localStorage.removeItem(key);
}
